import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services';
import { IWelcomeStep, IStep, stepCategory, IStepCategory } from '@app/models';


class GettingStartedService {
    getWelcomeSteps(): AxiosPromise {
        return apiService.get('/api/directory/WelcomeSteps')
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getTrialDaysRemaining(): AxiosPromise {
        return apiService.get('/api/directory/WelcomeSteps/TrialDaysRemaining')
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    sortedSteps(steps: IWelcomeStep[]) {
        return this.sortSteps(steps);
    }

    private sortSteps(steps: IWelcomeStep[]): IStepCategory[] {

        let sortedSteps: IStepCategory[] = [
            {
                categoryName: stepCategory.category1,
                steps: []
            },
            {
                categoryName: stepCategory.category2,
                steps: []
            },
            {
                categoryName: stepCategory.category3,
                steps: []
            },
            {
                categoryName: stepCategory.category4,
                steps: []
            }
        ]

        steps.forEach((step: IWelcomeStep) => {
        let stepData: IStep = JSON.parse(step.Step);
        stepData.completed = step.Completed;

            switch (stepData.category) {
                case stepCategory.category1:
                    sortedSteps[0].steps.push(stepData);
                    break;
                case stepCategory.category2:
                    sortedSteps[1].steps.push(stepData);
                    break;
                case stepCategory.category3:
                    sortedSteps[2].steps.push(stepData);
                    break;
                case stepCategory.category4:
                    sortedSteps[3].steps.push(stepData);
                    break;
                default:
                    break;
            }

        });

        return sortedSteps;
    }
}

export const gettingStartedService = new GettingStartedService();
